import type { Room } from '../RoomSelector.types';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    roomCapacityAriaLabel,
    roomCityAriaLabel,
    roomFeatureAudioLabel,
    roomFeatureDisplayLabel,
    roomFeatureVideoLabel,
    roomFeatureAccessibleLabel,
} from '../RoomResultsList.locstring.json';
import loc, { format } from 'owa-localize';

export default function getRoomFeaturesAriaLabels(room: Room) {
    let stringBuilder = [];
    if (isFeatureEnabled('cal-advancedRoomBooking')) {
        if (room.capacity != null && room.capacity > 0) {
            stringBuilder.push(format(loc(roomCapacityAriaLabel), room.capacity));
        }
        if (room.city) {
            stringBuilder.push(format(loc(roomCityAriaLabel), room.city));
        }
        if (room.audioDeviceName) {
            if (room.audioDeviceName == '1') {
                stringBuilder.push(loc(roomFeatureAudioLabel));
            } else {
                stringBuilder.push(room.audioDeviceName);
            }
        }
        if (room.displayDeviceName) {
            if (room.displayDeviceName == '1') {
                stringBuilder.push(loc(roomFeatureDisplayLabel));
            } else {
                stringBuilder.push(room.displayDeviceName);
            }
        }
        if (room.videoDeviceName) {
            if (room.videoDeviceName == '1') {
                stringBuilder.push(loc(roomFeatureVideoLabel));
            } else {
                stringBuilder.push(room.videoDeviceName);
            }
        }
        if (room.isWheelChairAccessible) {
            stringBuilder.push(loc(roomFeatureAccessibleLabel));
        }
    }
    return stringBuilder.join(', ');
}
